import { getStoredLanguage, normalizeLanguage } from "../i18n/language";
import type { SettingsAction } from "./actions";
import {
  DEFAULT_INTERFACE_PREFERENCES,
  normalizeInterfacePreferences,
  InterfacePreferences
} from "../utility/interfacePreferences";

const settings: { themeColor: string; language: string; interfacePreferences: InterfacePreferences } = {
  themeColor: "green",
  language: getStoredLanguage(),
  interfacePreferences: DEFAULT_INTERFACE_PREFERENCES
};

export const settingsReducer = (state = settings, action: SettingsAction): typeof settings => {
  switch (action.type) {
    case "setThemeColor": {
      return {
        ...state,
        themeColor: action.payload
      };
    }
    case "setLanguage": {
      return {
        ...state,
        language: normalizeLanguage(action.payload)
      };
    }
    case "setInterfacePreferences": {
      return {
        ...state,
        interfacePreferences: normalizeInterfacePreferences(action.payload)
      };
    }
    case "setInterfacePreference": {
      const key = action.payload?.key;
      if (!(key in DEFAULT_INTERFACE_PREFERENCES)) return state;
      return {
        ...state,
        interfacePreferences: normalizeInterfacePreferences({
          ...state.interfacePreferences,
          [key]: action.payload?.value
        })
      };
    }
    default:
      return state;
  }
};
